var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1588073885514,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5428,
    width: 32,
    height: 32,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M680.5504 640.887467a30.651733 30.651733 0 0 1 0 43.4176c-6.007467 6.007467-13.858133 9.0112-21.7088 9.0112-7.850667 0-15.701333-3.003733-21.7088-9.0112L512.068267 559.3088l-125.064534 125.064533c-6.007467 6.007467-13.858133 9.0112-21.7088 9.0112-7.850667 0-15.701333-3.003733-21.7088-9.0112a30.651733 30.651733 0 0 1 0-43.4176l125.064534-125.064533-125.064534-125.1328a30.651733 30.651733 0 0 1 0-43.4176 30.651733 30.651733 0 0 1 43.4176 0L512.068267 472.405333l125.064533-125.064533a30.651733 30.651733 0 0 1 43.4176 0 30.651733 30.651733 0 0 1 0 43.4176L555.554133 515.822933l124.996267 125.064534z",
    "p-id": 5429,
    fill: "#433938"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.c51fd928eb241445e06da97bcbfa5f5d.svg";